import { render, staticRenderFns } from "./FolderItem.vue?vue&type=template&id=1469edb2&scoped=true&"
import script from "./FolderItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./FolderItem.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1469edb2",
  null
  
)

export default component.exports